<div class="progress-bar-outer" *ngIf="showLoader" [@loader]>
  <div class="progress-bar-inner" [style.width]="width + '%'"></div>
</div>
